// extracted by mini-css-extract-plugin
module.exports = {"reportDivider":"ReportTableListQualifiedGroupOverview_reportDivider__rD37y"};